
(function () {
  'use strict';
  angular.module('vcdms.vcprinter')
    .component('printersearch', {
      restrict: 'E',
      bindings: {
      printer: '<',
  printerref: '<',
    parentsave: '&?',
    editinplace: '@?',
    ti: '@?'
},
  template: `
        <div class="form-group">
          <div class="input-group">
                <input type="text" class="form-control" tabindex="{{vm.tabi}}"
                   ng-class="{'dirtyfield': vm.asyncSelected.length > 0}"
                   placeholder="Kürzel"
                   ng-model="vm.asyncSelected"
                   typeahead-on-select="$parent.$dismiss();vm.showprinter($item, $model, $label)"
                   uib-typeahead="printer as printer.text for printer in vm.getPrinters($viewValue)"
                   typeahead-loading="loadingNames"
                   typeahead-no-results="noResults">
            <span class="input-group-btn">
              <button type="submit"
                      ng-class="{'btn-warning': noResults, 'btn-info': !noResults}"
                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>
            </span>
          </div>
        </div>
        
        
        <i ng-show="loadingNames" class="fa fa-refresh"></i>
        <div ng-show="noResults">
          <i class="fa fa-remove"></i> Keine SV gefunden
          <span class="btn btn-success" ng-click="vm.addPrinter()" ng-hide="vm.error">Neue Sozialversicherung eingeben</span>
          <span ng-click="vm.addPrinter()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Sozialversicherung konnte nicht angelegt werden!</span>
        </div>
        
        <div ng-show="vm.editinplace === true">
          <printereditor printer="vm.printer"></printereditor>
        </div>
        
        
      `,
    controllerAs: 'vm',
    controller: ['$log', 'Printer', 'PrinterHelper',
    function ($log, Printer, PrinterHelper) {
    let vm = this;
    vm.save = save;
    vm.showprinter = showprinter;
    
    vm.getPrinters = getPrinters;
    // vm.addPrinter = PrinterHelper.addPrinter;
    vm.addPrinter = addPrinter;
    vm.editPrinter = PrinterHelper.editPrinter;
    
    vm.$onInit = function () {
      vm.newprinter = {};
      
      if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
        vm.editinplace = true;
      }
      
      $log.debug('debug - editinplace', vm.editinplace);
      
      
      if (angular.isUndefined(vm.ti))  {
        vm.ti = 0;
        vm.tabi = 0;
      }
      if (angular.isString(vm.ti)) {
        vm.tabi = parseInt(vm.ti, 10);
      }
      else {
        vm.tabi = 0;
      }
      vm.lastprinter = angular.copy(vm.printerresult);
      vm.lastprinterref = angular.copy(vm.printerref);
    };
    
    function addPrinter() {
      $log.debug('debug - printersearch addPrinter called');
    PrinterHelper.addPrinter(function (printer) {
        $log.debug('debug: handle newly create printer');
        vm.printer = {};
        vm.printer.name = printer.name;
        vm.printer.short = printer.short;
        vm.printer._id = printer._id;
        vm.printerref = printer._id;
        vm.asyncSelected = printer.short;
        vm.parentsave({printer: vm.printer, printerref: vm.printerref});
      }, function (err) {
        vm.error = true;
        $log.error(err);
      });
    }
    
    
    // typeahead printer search backend query
    function getPrinters(val) {
      // return Printerahead.$search({query: val}).$asPromise().then(function (response) {
      return Printer.$searchahead({query: val}).$asPromise().then(function (response) {
        return response.map(function (printer) {
        printer.text = printer.short;
          delete vm.error;
          return printer;
        });
      });
    }
    
    // typeahead printer search action
    function showprinter($item, $model, $label) {
      /* jshint unused:false */
      /* eslint "no-unused-lets": [2, {"args": "none"}] */
      vm.printer = $model;
      vm.printerref = $model._id;
      delete vm.asyncSelected;
      vm.editinplace = true;
      $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
      if (vm.editinplace === true) {
        vm.printer = $model;
        vm.printerref = $model._id;
        $log.debug('debug - printersearch editinplace');
      }
      else {
        vm.printer = {};
        vm.printer.name = $model.name;
        vm.printer.short = $model.short;
        vm.printer._id = $model._id;
        vm.printerref = $model._id;
        vm.parentsave({printer: vm.printer, printerref: vm.printerref});
        $log.debug('debug - printersearch do not  editinplace', vm.parentsave);
      }
    }
    
    function save() {
      if (!angular.equals(vm.printer, vm.lastprinter) || !angular.equals(vm.printerref, vm.lastprinterref) ) {
        vm.lastprinter = angular.copy(vm.printer);
        vm.lastprinterref = angular.copy(vm.printerref);
        vm.parentsave({printer: vm.printer, printerref: vm.printerref});
      }
    }
    
    
  }] // controller
}); // component

// klammerfriedhof
}());